module.exports = __webpack_public_path__ + "img/pantalla-2-10.b13079a1.png";